import { MapPin } from "lucide-react";
import { RuntimeLink } from "../../runtime/RendererRuntime";
import type { LinkTarget } from "../../types";
import { resolveLinkHref } from "../../utils/links";

export type EventItem = {
  tag: string;
  title: string;
  location: string;
  href: LinkTarget;
  startDay: number | string;
  endDay?: number | string;
  monthLabel: string; // e.g., "AOUT", "OCTOBRE"
};

/** Event card with date block, tag, title and location. */
export function EventCard({ tag, title, location, href, startDay, endDay, monthLabel }: EventItem) {
  const safeHref = resolveLinkHref(href) ?? "/";
  return (
    <RuntimeLink href={safeHref} className="group flex overflow-hidden bg-white">
      {/* Date block */}
      <div className="flex w-24 sm:w-28 shrink-0 flex-col items-center justify-center bg-[#00B862] px-3 py-4 text-white">
        <div className="text-base xl:text-lg font-semibold leading-tight sm:text-lg">
          {startDay}{endDay ? " > " + endDay : ""}
        </div>
        <div className="text-[10px] uppercase tracking-wide sm:text-xs">{monthLabel}</div>
      </div>

      {/* Content */}
      <div className="flex min-h-[92px] flex-1 flex-col justify-center bg-slate-50 px-4 py-3">
        <div className="text-[10px] font-semibold uppercase tracking-wide text-[#00B862]">{tag}</div>
        <div className="mt-1 line-clamp-2 text-sm xl:text-base font-medium leading-5 text-[#00B862]">
          {title}
        </div>
        <div className="mt-2 flex items-center gap-2 text-xs xl:text-sm text-slate-600">
          <MapPin className="h-3.5 w-3.5 text-[#FFC105]" />
          <span>{location}</span>
        </div>
      </div>
    </RuntimeLink>
  );
}


